import React, { useState, useEffect } from 'react';
import { Bar } from 'react-chartjs-2';
import 'chart.js/auto';
import axios from 'axios';
import heloicon from '../../../safreeimg/superadminimg/heloicon.png';

const Page1 = () => {
  const [chartData, setChartData] = useState({
    labels: ['Total Users', 'Total Alarms', 'Total Groups', 'Total SubGroups'],
    datasets: [
      {
        label: 'Statistics',
        data: [0, 0, 0, 0], 
        backgroundColor: ['#4CAF50', '#FFC107', '#2196F3', '#FF5722'],
        borderColor: ['#388E3C', '#FFA000', '#1976D2', '#E64A19'],
        borderWidth: 1,
      },
    ],
  });

  const currentYear = new Date().getFullYear(); 
  const [selectedYear, setSelectedYear] = useState(currentYear); 
  const [selectedMonth, setSelectedMonth] = useState('January'); 

  const years = Array.from({ length: 11 }, (_, i) => currentYear - 5 + i);

  const [dashboardData, setDashboardData] = useState({
    totalUsers: 0,
    totalAlarms: 0,
    totalGroups: 0,
    totalSubGroups: 0,
  });

  const [subscriptionData, setSubscriptionData] = useState({
    isSubscriptionActive: false,
    subscriptionExpiryDate: '',
    subscriptionUsers: '',
  });

  // 📡 Fetch Dashboard Data
  const fetchDashboardData = async () => {
    const apiUrl = 'https://api.safree.org/api-v2022/organization/auth/v1/org-total-counts';
    const token = localStorage.getItem('token');

    if (!token) {
      console.error('Authentication token is missing!');
      return;
    }

    try {
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: token,
          'Content-Type': 'application/json',
        },
      });

      if (response.data.success) {
        setDashboardData(response.data.data);
      } else {
        console.error('Failed to fetch dashboard data:', response.data.message);
      }
    } catch (error) {
      console.error('API Error:', error.message);
    }
  };

  // 📡 Fetch Filtered Data
  const fetchFilteredData = async () => {
    const apiUrl = 'https://api.safree.org/api-v2022/organization/auth/v1/org-monthly-total-counts';
    const token = localStorage.getItem('token');

    if (!token) {
      console.error('Authentication token is missing!');
      return;
    }

    const requestData = {
      year: selectedYear,
      month: selectedMonth.toUpperCase(),
    };

    try {
      const response = await axios.post(apiUrl, requestData, {
        headers: {
          Authorization: token,
          'Content-Type': 'application/json',
        },
      });

      if (response.data.success) {
        const { totalUsers, totalAlarms, totalGroups, totalSubGroups } = response.data.data;
        setChartData({
          ...chartData,
          datasets: [
            {
              ...chartData.datasets[0],
              data: [totalUsers, totalAlarms, totalGroups, totalSubGroups],
            },
          ],
        });
      } else {
        console.error('Failed to fetch data:', response.data.message);
      }
    } catch (error) {
      console.error('API Error:', error.message);
    }
  };

  // 🚀 Fetch Subscription Data
  const fetchSubscriptionData = async () => {
    const apiUrl = 'https://api.safree.org/api-v2022/organization/auth/v1/my/subscription';
    const token = localStorage.getItem('token');

    if (!token) {
      console.error('Authentication token is missing!');
      return;
    }

    try {
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: token,
          'Content-Type': 'application/json',
        },
      });

      if (response.data.success) {
        setSubscriptionData(response.data.data);
      } else {
        console.error('Failed to fetch subscription data:', response.data.message);
      }
    } catch (error) {
      console.error('API Error:', error.message);
    }
  };

  useEffect(() => {
    fetchDashboardData();
    fetchFilteredData();
    fetchSubscriptionData(); // 📡 Subscription API Call
  }, [selectedYear, selectedMonth]);

  return (
    <div className="container user-management">
      <div className="row header">
        <div className="col-md-6">
          <p className="sub-heading">Dashboard</p>
        </div>
        <div className="col-md-6 subdetail">
          <h2>Subscription Status: <span>{subscriptionData.isSubscriptionActive ? 'Active' : 'Inactive'}</span></h2>
          <h2>Expiry Date: <span>{subscriptionData.subscriptionExpiryDate}</span></h2>
          <h2>Subscribed Users: <span>{subscriptionData.subscriptionUsers}</span></h2>
        </div>
      </div>

      <div className="cards-container">
        <a href="/admin2/orgUserManagement">
        <div className="cards">
          <h3>Total Users</h3>
          <p>{dashboardData.totalUsers}</p>
        </div>
        </a>
        <a href="/admin2/orgAlarmManagement">
        <div className="cards">
          <h3>Total Alarms</h3>
          <p>{dashboardData.totalAlarms}</p>
        </div>
        </a>
        <a href="/admin2/orgGroupManagement">
        <div className="cards">
          <h3>Total Groups</h3>
          <p>{dashboardData.totalGroups}</p>
        </div>
        </a>
        <a href="/admin2/orgGroupManagement">
        <div className="cards">
          <h3>Total SubGroups</h3>
          <p>{dashboardData.totalSubGroups}</p>
        </div>
        </a>
      </div>

      <div className="filters">
        <label>
          Year:
          <select
            value={selectedYear}
            onChange={(e) => setSelectedYear(Number(e.target.value))}
          >
            {years.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>
        </label>
        <label>
          Month:
          <select value={selectedMonth} onChange={(e) => setSelectedMonth(e.target.value)}>
            {['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'].map((month) => (
              <option key={month} value={month}>
                {month}
              </option>
            ))}
          </select>
        </label>
      </div>

      <div className="chart-container" style={{ marginTop: '30px' }}>
        <Bar data={chartData} />
      </div>
    </div>
  );
};

export default Page1;
